import {invokeApi} from "../utils/invokeApi";

/*
 * Parental consent — the page a parent reaches from the "I consent and
 * activate" email (Case 2). The parent is not signed in: the consent_token in
 * the link is the whole authorisation.
 */

/** What the page shows. Reads only — opening the link records nothing. */
export const getConsentRequest = (consent_token) => {
    let requestObj = {
        path   : '/my_dq/consent/request',
        method : 'GET',
        queryParams : {
            consent_token
        }
    };

    return invokeApi(requestObj);
}

/** Records the parent's consent — only on the press of the button. */
export const confirmConsent = (consent_token) => {
    let requestObj = {
        path   : '/my_dq/consent/confirm',
        method : 'POST'
    };
    requestObj['postData'] = {
        consent_token
    };

    return invokeApi(requestObj);
}
